import { type DetailedHTMLProps, type HTMLAttributes } from 'react';
import { classNames } from '@utils/classNames.ts';

export function Body3({
  children,
  className,
  ...rest
}: DetailedHTMLProps<
  HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>) {
  return (
    <span
      className={classNames('text-sm leading-6 font-normal block', className)}
      {...rest}
    >
      {children}
    </span>
  );
}
